<template>
  <section class="builder-search-results-list">
    <div class="container">
      <div v-if="companyStore.companytData.hits.length" class="row justify-content-center __builder-result-items-wrapper">
        <TransitionGroup name="list">
          <div v-for="(hit, key) in companyStore.companytData.hits" :key="`builder-raw-${key}`" class="__builder-item-wrapper col-12">
            <BuilderWidget widget-type="Info raw" :builder="hit.document" :analytics-event-data="{displayedLocation: 'Builders page', position: (key + 1) as number}" max-width="100%" />
          </div>
        </TransitionGroup>
      </div>
      <div class="fade-effect" />
    </div>
  </section>
</template>

<script setup lang="ts">
import {useCompanyStore} from '~/store/company';

const companyStore = useCompanyStore();
</script>

<style lang="scss">
.builder-search-results-list {
  background: #fff;
  position: relative;

  .__builder-result-items-wrapper {
    padding-bottom: 30px;
  }

  .fade-effect {
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    height: 50px;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    pointer-events: none;
  }

  .__builder-item-wrapper {
    padding: 20px 0;
    border-bottom: 1px solid #efefef;

    .__builder-logo {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100px;
        max-height: 80px;
      }
    }

    .__builder-name-and-ownership {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 100%;

      a {
        text-decoration: unset;

        h3 {
          font-size: 16px;
          font-weight: 400;
          color: rgba(var(--text-default), 0.8);
          text-decoration: unset;
        }

        .__builder-ownership {
          font-size: 12px;
          font-weight: 400;
          color: rgba(var(--text-default), 0.5);
          text-decoration: unset;
        }
      }
    }

    .__builder-services {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 100%;

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          font-size: 15px;
          font-weight: 400;
          color: rgba(var(--text-default), 0.7);
          text-decoration: unset;
          padding: 4px 0;
        }
      }
    }

    .__builder-warranty {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 100%;

      font-size: 15px;
      font-weight: 400;
      color: rgba(var(--text-default), 0.7);
      text-decoration: unset;
    }
  }
}
</style>
